module.exports = __webpack_public_path__ + "media/product/t-2-6159d8a3.png";